import api from './api';
import { PhotosResponse, UploadResponse } from '../types';

export interface PhotoFilters {
  page?: number;
  limit?: number;
  hasTag?: boolean;
}

export const photoService = {
  async getPhotos(filters: PhotoFilters = {}): Promise<PhotosResponse> {
    const params = new URLSearchParams();
    
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        params.append(key, value.toString());
      }
    });

    const url = `/photos?${params}`;
    console.log('📡 API Request:', url, filters);
    
    const response = await api.get<PhotosResponse>(url);
    console.log('📨 API Response:', response.data.pagination);
    
    return response.data;
  },

  async uploadPhotos(files: File[]): Promise<UploadResponse> {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('photos', file);
    });

    const response = await api.post<UploadResponse>('/photos/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 120000, // 2 minutes for large uploads
    });

    return response.data;
  },

  async updatePhotoTags(photoId: number, tagIds: number[]): Promise<any> {
    const response = await api.put(`/photos/${photoId}/tags`, { tagIds });
    return response.data;
  },

  async bulkTagPhotos(
    photoIds: number[],
    tagIds: number[],
    action: 'add' | 'remove' | 'replace'
  ): Promise<any> {
    const response = await api.post('/photos/bulk-tag', {
      photoIds,
      tagIds,
      action,
    });
    return response.data;
  },

  async downloadPhoto(photoId: number): Promise<Blob> {
    const response = await api.get(`/photos/${photoId}/download`, {
      responseType: 'blob'
    });
    return response.data;
  },

  async downloadMultiplePhotos(photoIds: number[]): Promise<Blob> {
    const response = await api.post('/photos/download', 
      { photoIds },
      { responseType: 'blob' }
    );
    return response.data;
  },
};